import * as React from 'react'

/**
 * Below this the sidebar becomes a sheet over the content rather than a
 * column beside it. 1024 because that is where this app's own `lg:` rules
 * switch, and two breakpoints for one decision is one too many.
 */
const MOBILE_BREAKPOINT = 1024

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    /*
     * GUARDED, because `matchMedia` is not universal. jsdom does not
     * implement it at all, so without this every test that mounts the app
     * frame dies in a layout hook — and a missing media-query API is
     * "assume the desktop layout", not a crash.
     */
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return

    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    mql.addEventListener('change', onChange)
    onChange()
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return !!isMobile
}
